import SocialMediaType from '@/enums/SocialMediaType';

const state = {
  reviews: [],
  isLoadingMediaReviewCollage: true,
  pagy: {},
  totalMediaCount: 0,
  activeTab: 'all'
};

const mutations = {
  SET_REVIEWS(state, { reviews }) {
    state.reviews = reviews;
  },
  APPEND_REVIEWS(state, { reviews }) {
    state.reviews = [...state.reviews, ...reviews];
  },
  SET_IS_LOADING_MEDIA_REVIEW_COLLAGE(state, isLoadingMediaReviewCollage) {
    state.isLoadingMediaReviewCollage = isLoadingMediaReviewCollage;
  },
  SET_PAGY(state, pagy) {
    state.pagy = pagy;
  },
  SET_TOTAL_MEDIA_COUNT(state, totalMediaCount) {
    state.totalMediaCount = totalMediaCount;
  },
  SET_ACTIVE_TAB(state, activeTab) {
    state.activeTab = activeTab;
  }
};

const getters = {
  reviewMedia: ({ reviews, activeTab }, _getters, _rootState, rootGetters) => {
    const media = [];
    const videoOnly = activeTab === 'video';
    reviews.forEach(review => {
      const mediaCount =
        review.social_media_type === SocialMediaType.INSTAGRAM
          ? 1
          : videoOnly
          ? review.videos.length
          : review.videos.length + review.images.length;
      for (let i = 0; i < mediaCount; ++i) {
        media.push({
          review: rootGetters['review/displayableReview'](review),
          media_position: i + 1
        });
      }
    });

    return media;
  }
};

const COLLAGE_PER = 13;
const actions = {
  fetchProductMediaReviewCollage({ commit, rootState }, args) {
    const { init, ...params } = args;
    const product_code = rootState.productCode;
    const parent_widget_id = rootState.widget.widget.parent_widget_id;
    commit('SET_IS_LOADING_MEDIA_REVIEW_COLLAGE', true);
    return rootState.api
      .fetchProductMediaReviews(product_code, {
        parent_widget_id,
        per: COLLAGE_PER,
        ...params
      })
      .then(({ data }) => {
        commit(init ? 'SET_REVIEWS' : 'APPEND_REVIEWS', {
          reviews: data.reviews
        });
        commit('SET_PAGY', data.pagy);
        commit('SET_TOTAL_MEDIA_COUNT', data.total_media_count);
      })
      .finally(() => {
        commit('SET_IS_LOADING_MEDIA_REVIEW_COLLAGE', false);
      });
  }
};

export default { namespaced: true, state, getters, mutations, actions };
